import { Theme } from '@mui/material';

export const raToolBarTheme = (theme: Theme) => ({
    styleOverrides: {
        root: {
            backgroundColor: 'unset',
            [theme.breakpoints.up('sm')]: {
                padding: 0,
            },
        },
    },
});
